import React from "react";

export default function CreateStoryCard({ user, onClick }) {
  return (
    <div className="create_story_card" onClick={onClick}>
      <div className="create_story_image">
        <img src={user?.picture} alt={user?.first_name} />
        <div className="create_story_plus">
          <i className="plus_icon"></i>
        </div>
      </div>
      <div className="create_story_text">Create Vibe</div>
    </div>
  );
} 